import { FC } from "react";
import { StandardHandler } from "../../../middleware/handlers/standard-handler";

interface SectionMenuProps {
  sectionPanelReveal: boolean;
}

export const SectionMenu: FC<SectionMenuProps> = ({ sectionPanelReveal }) => {
  if (!sectionPanelReveal) return null;

  return (
    <div className="viewerToolPanel">
      <div className="viewerToolPanelHeader">
        <span className="viewerToolPanelLabel">SECTION</span>
        <span className="viewerToolPanelName">Cut the model open</span>
      </div>
      <div className="viewerToolRowWrapper">
        <span className="viewerToolRowHint">
          Double-click a surface to add a section plane facing it. Drag the
          plane's arrow to move the cut.
        </span>
        <span className="viewerToolRowHint">
          Planes stay in place when this panel is closed.
        </span>
      </div>
      <div className="viewerToolPanelFooter">
        <span>Hover a plane and press Delete to remove it.</span>
        <input
          type="button"
          value="Remove all section planes"
          onClick={() => {
            StandardHandler.ClearSections();
          }}
        />
      </div>
    </div>
  );
};

export default SectionMenu;
